import initialState from './adoptionInitialState';
import mutations from './adoptionMutation';
import actions from './adoptionAction';

const adoptionModule = {
  state: initialState(),
  mutations,
  actions,
  getters: {},
};

export default adoptionModule;
